import { PreviewPageBox } from "@/app/report/common/export/previewPagination"

import "./previewPageLayer.scss"

/**
 * 미리보기 뒤에 깔리는 A4 페이지 박스.
 *
 * 콘텐츠 자체는 건드리지 않고 배경만 그린다 — 덩어리들은 applyPreviewPagination 이
 * margin 으로 제자리에 밀어 놓는다. 캡처 대상(섹션) 바깥이라 PDF 에는 들어가지 않는다.
 */
export default function PreviewPageLayer({ pages }: { pages: PreviewPageBox[] }) {
  if (pages.length === 0) {
    return null
  }

  return (
    <div className="PreviewPageLayer" aria-hidden data-html2canvas-ignore>
      {pages.map((page) => (
        <div
          key={page.page}
          className="PreviewPage"
          style={{
            top: `${page.topPx}px`,
            left: `${page.leftPx}px`,
            width: `${page.widthPx}px`,
            height: `${page.heightPx}px`,
          }}>
          <span className="PreviewPageNumber">{page.page}</span>
        </div>
      ))}
    </div>
  )
}
